<template>
    <section class="media --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        <div class="media__content-mobile">
          <div class="media__content-mobile__column image">
            <img src="../assets/media/astronaut_image.jpg">
          </div>
          <div class="media__content-mobile__column quote">
            <p>
            “MHHC results are achieved through sensible, expedient, and proactive understanding and protection of consumers goods and the goods manufacturers delivered to their clients.”
            </p>
          </div>
          <div class="media__content-mobile__column image">
            <img src="../assets/media/lock_image.jpg">
          </div>
        </div>
        <div class="media__content">
          <div class="media__column-1">
            <img src="../assets/media/wire_logic-1.jpg">
          </div>
          <div class="media__column-2">
            <img src="../assets/media/wire_logic-2.jpg">
          </div>
        </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'media',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/media.scss";
  </style>